export const COLORS = {
  Nature: "#98a886",
  Architecture: "#16B0B2",
  Hiking: "#585123",
  Wintersports: "#3f8efc",
  Beach: "#7b2cbf",
  Culture: "#f72585",
  Culinary: "#f57eb6",
  Entertainment: "#b56576",
  Shopping: "#c08552",
};

export const popularityParameters = ['Personalization', 'Popularity', 'Variety'];
export const noveltyParameters = ['Personalization', 'Low Popularity', 'Variety'];
export const popularityParameterColors = ["#3b82f6", "#ef4444", "#22c55e"];
export const noveltyParameterColors = ["#3b82f6", "#960089", "#22c55e"];
